/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { PaginatedResponse_TaskMapResponse_ } from '../models/PaginatedResponse_TaskMapResponse_';
import type { TaskMapCreateRequest } from '../models/TaskMapCreateRequest';
import type { TaskMapResponse } from '../models/TaskMapResponse';
import type { TaskMapSortRequest } from '../models/TaskMapSortRequest';
import type { TaskMapUpdateRequest } from '../models/TaskMapUpdateRequest';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class TaskMapService {
    /**
     * Create Task Map
     * 세부실행과제 연결 생성
     *
     * 전략과제 하위그룹과 세부실행과제를 연결합니다.
     * @returns TaskMapResponse Created
     * @throws ApiError
     */
    public static appsTaskViewsCreateTaskMap({
        requestBody,
    }: {
        requestBody: TaskMapCreateRequest,
    }): CancelablePromise<TaskMapResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/task/map',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                409: `Conflict`,
                500: `Internal Server Error`,
            },
        });
    }
    /**
     * List Task Maps
     * 세부실행과제 연결 목록 조회
     *
     * 세부실행과제 연결을 페이징하여 조회합니다.
     *
     * Args:
     * task_sub_group_id: 전략과제 하위그룹 ID로 필터링 (선택사항)
     * task_id: 세부실행과제 ID로 필터링 (선택사항)
     * @returns PaginatedResponse_TaskMapResponse_ OK
     * @throws ApiError
     */
    public static appsTaskViewsListTaskMaps({
        taskSubGroupId,
        taskId,
        page = 1,
        perPage = 100,
    }: {
        taskSubGroupId?: string,
        taskId?: string,
        page?: number,
        perPage?: number,
    }): CancelablePromise<PaginatedResponse_TaskMapResponse_> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/task/map',
            query: {
                'task_sub_group_id': taskSubGroupId,
                'task_id': taskId,
                'page': page,
                'per_page': perPage,
            },
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                404: `Not Found`,
                500: `Internal Server Error`,
            },
        });
    }
    /**
     * Get Task Map
     * 세부실행과제 연결 조회
     *
     * ID로 특정 연결을 조회합니다.
     * @returns TaskMapResponse OK
     * @throws ApiError
     */
    public static appsTaskViewsGetTaskMap({
        mapId,
    }: {
        mapId: number,
    }): CancelablePromise<TaskMapResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/task/map/{map_id}',
            path: {
                'map_id': mapId,
            },
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                404: `Not Found`,
                500: `Internal Server Error`,
            },
        });
    }
    /**
     * Update Task Map
     * 세부실행과제 연결 수정
     *
     * 세부실행과제 연결의 overwrite_name을 수정합니다.
     * overwrite_name을 null로 설정하면 원본 과제명을 사용합니다.
     * @returns TaskMapResponse OK
     * @throws ApiError
     */
    public static appsTaskViewsUpdateTaskMap({
        mapId,
        requestBody,
    }: {
        mapId: number,
        requestBody: TaskMapUpdateRequest,
    }): CancelablePromise<TaskMapResponse> {
        return __request(OpenAPI, {
            method: 'PATCH',
            url: '/api/task/map/{map_id}',
            path: {
                'map_id': mapId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                404: `Not Found`,
                500: `Internal Server Error`,
            },
        });
    }
    /**
     * Delete Task Map
     * 세부실행과제 연결 삭제
     *
     * 특정 연결을 삭제합니다.
     * @returns void
     * @throws ApiError
     */
    public static appsTaskViewsDeleteTaskMap({
        mapId,
    }: {
        mapId: number,
    }): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/api/task/map/{map_id}',
            path: {
                'map_id': mapId,
            },
            errors: {
                401: `Unauthorized`,
                404: `Not Found`,
                500: `Internal Server Error`,
            },
        });
    }
    /**
     * Update Task Map Sort
     * 세부실행과제 연결 정렬 순서 변경
     *
     * 세부실행과제 연결의 정렬 순서를 변경합니다.
     * prev_task_map_id와 next_task_map_id를 기반으로 중간값을 계산하여 sort_key를 설정합니다.
     *
     * - 맨 앞으로 이동: prev_task_map_id=None, next_task_map_id=첫번째항목ID
     * - 맨 뒤로 이동: prev_task_map_id=마지막항목ID, next_task_map_id=None
     * - 중간 삽입: prev_task_map_id=이전항목ID, next_task_map_id=다음항목ID
     * @returns TaskMapResponse OK
     * @throws ApiError
     */
    public static appsTaskViewsUpdateTaskMapSort({
        mapId,
        requestBody,
    }: {
        mapId: number,
        requestBody: TaskMapSortRequest,
    }): CancelablePromise<TaskMapResponse> {
        return __request(OpenAPI, {
            method: 'PATCH',
            url: '/api/task/map/{map_id}/sort',
            path: {
                'map_id': mapId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                404: `Not Found`,
                500: `Internal Server Error`,
            },
        });
    }
}
